/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngTemplateOutletContext directives.
 */

import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicTabDirective } from './dynamictabdirective.directive';

@Component({
  selector: 'frms-tab',
  styles: [
    `
    .pane{
      padding: 1em;
    }
  `
  ],
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
      <ng-template dynamic-tab></ng-template>
    </div>
  `
})
export class TabComponent implements OnInit{

  @ViewChild(DynamicTabDirective, {static: true}) componentHost: DynamicTabDirective;

  @Input('tabTitle') title: string;
  @Input() id =-1;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() component;
  @Input() dataContext;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {

    this.loadComponent( this.id,this.title,this.component,this.dataContext,this.isCloseable);
  }

  loadComponent(id:any, title: string, component, data, isCloseable = false) {
    if (!component){
      return;
    }
      // get a component factory for our TabComponent
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory( component );
  
      const viewContainerRef = this.componentHost.viewContainerRef;
      //viewContainerRef.clear();

  
      // alternatively...
      // let viewContainerRef = this.dynamicTabPlaceholder;
  
      // create a component instance
      const componentRef = viewContainerRef.createComponent(componentFactory);
      let anyComp:any=componentRef.instance;
      for (let [key, value] of Object.entries(data)){
        anyComp[key] = value;
      }
      
  
      // set the according properties on our component instance
      const instance: TabComponent = componentRef.instance as TabComponent;
      instance.id=id;
      instance.title = title;
      instance.template = component;
      instance.dataContext = data;
      instance.isCloseable = isCloseable;
  
      // remember the dynamic component for rendering the
      // tab navigation headers
      //this.dynamicTabs.push(componentRef.instance as TabComponent);
  
      // set it active
      //this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    }
  }

